module.exports = __webpack_public_path__ + "static/3-Bird detail-2735368a810e7c27ffdce583e184f028.jpg";